<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <u-icon>Ù</u-icon>
      </div>
      <div>
        <div><span>Questionnaire</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <v-tabs v-model="selectedPage"
              slider-color="other2"
              background-color="validLight"
              slider-size="3"
              color="white"
              active-class="essai"
      >
        <v-tab v-for="(pageNumber, index) in workingPagesNumber"
               :key="index"
               ripple
        >
          Page {{ pageNumber }}
        </v-tab>
      </v-tabs>

      <questionnaire-builder
        @save="saveWorkingPages"
        v-if="dataLoaded"
        :selected-page="selectedPage"
        @next="selectedPage++"
      />
      <template v-else>
        <v-progress-linear :indeterminate="true"
                           height="3"
        />
      </template>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import QuestionnaireBuilder from '@/components/questionnaires/QuestionnaireBuilder'

export default {
  name: 'questionnaireCreation',
  components: {
    QuestionnaireBuilder
  },
  data () {
    return {
      selectedPage: 0,
      dataLoaded: false
    }
  },
  computed: {
    ...mapGetters('Questionnaires', [
      'workingPages',
      'questionnaire'
    ]),
    workingPagesNumber () {
      return this.workingPages.map(({ pageNumber }) => pageNumber)
    }
  },
  async created () {
    await this.questionnaireLoad(this.$route.params.id)
    await this.loadRepositoryQuestions()
    this.dataLoaded = true
  },
  methods: {
    ...mapActions('Questionnaires', [
      'questionnaireLoad',
      'saveWork'
    ]),
    ...mapActions('Questions', [
      'loadRepositoryQuestions'
    ]),
    saveWorkingPages () {
      this.saveWork(true)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
  @import "../../assets/style/colors";

  .essai {
    background-color: $buttonValidColor;
  }

  #app__ernest {
    .v-progress-linear {
      margin: 0;
    }
  }
</style>
